module.exports = __webpack_public_path__ + "media/images/front/event/clock-icon-d686e3ed7a7ca9004c006d19ce13869b.svg";